import React from 'react';
import {
  FaUsers,
  FaUser,
  FaRobot,
  // FaExclamationTriangle,
  // FaUserShield,
  // FaUserFriends,
  // FaClock,
  // FaBan,
  // FaShieldAlt 
} from 'react-icons/fa';
import { StatsCard } from '../../overview';
import './IdentityStats.css';

/**
 * IdentityStats Component
 * Displays identity statistics in a grid
 */
const IdentityStats = ({ stats, loading = false }) => {
  const primaryStats = [
    {
      title: 'Total Identities',
      value: stats?.total?.total_latest_identities,
      icon: <FaUsers />,
      iconColor: 'primary',
      trend:stats?.total?.percentage_change
    },
    {
      title: 'Human Identities',
      value: stats?.human_identities?.latest_total,
      icon: <FaUser />,
      iconColor: 'primary',
      trend:stats?.human_identities?.percentage_change
    },
    {
      title: 'Non-Human Identities',
      value: stats?.non_human_identities?.latest_total,
      icon: <FaRobot />,
      iconColor: 'success',
      trend:stats?.non_human_identities?.percentage_change
    },
    {
      title: 'Privileged Accounts',
      value: (stats?.risk_stats?.privilege_accounts?.latest_total || 0),
      icon: <FaUser />,
      iconColor: 'primary',
      trend:stats?.risk_stats?.privilege_accounts?.percentage_change

    }
  ];

  // const secondaryStats = [
  //   {
  //     title: 'Admin Users',
  //     value: stats?.adminUsers,
  //     icon: <FaUserShield />,
  //     iconColor: 'warning'
  //   },
  //   {
  //     title: 'Guest Users',
  //     value: stats?.guestUsers,
  //     icon: <FaUserFriends />,
  //     iconColor: 'info'
  //   },
  //   {
  //     title: 'Inactive (90+ days)',
  //     value: stats?.inactive,
  //     icon: <FaClock />,
  //     iconColor: 'secondary'
  //   },
  //   {
  //     title: 'Disabled',
  //     value: stats?.disabled,
  //     icon: <FaBan />,
  //     iconColor: 'danger'
  //   }
  // ];


  return (
    <div className="identity-stats">
      <div className="stats-grid stats-grid-primary">
        {primaryStats.map((stat, index) => (
          <StatsCard
            key={index}
            title={stat?.title}
            value={stat?.value}
            icon={stat?.icon}
            iconColor={stat?.iconColor}
            loading={loading}
            trend={stat?.trend}
          />
        ))}
      </div>
      
      {/* <div className="stats-grid stats-grid-secondary">
        {secondaryStats.map((stat, index) => (
          <StatsCard
            key={index}
            title={stat.title}
            value={stat.value}
            icon={stat.icon}
            iconColor={stat.iconColor}
            loading={loading}
          />
        ))}
      </div> */}

    </div>
  );
};

export default IdentityStats;